module.exports = __webpack_public_path__ + "static/media/uni-cc-02.f1243912.png";